import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommunicationConfigService } from '@argalis-apps/angular-global';
import { Observable } from 'rxjs';
import { MAmzone, MDocument } from '@argalis-apps/models';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private communicationConfigService: CommunicationConfigService, private http: HttpClient) {}

  getDocumentPresigned(id: number, table: string): Observable<MDocument.IDocumentPresignedResponse> {
    return this.http.get<MDocument.IDocumentPresignedResponse>(
      `${this.communicationConfigService.getApiUri()}/document/document-presigned`,
      {
        params: { table_linked: table, id: id.toString() }
      }
    );
  }

  insertDocument(
    table: string,
    idTableLinked: number,
    bodyReq: MAmzone.IAmazoneUploadReponse
  ): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(
      `${this.communicationConfigService.getApiUri()}/document/table/${table}/${idTableLinked}`,
      bodyReq
    );
  }

  deleteDocument(idDoc: number) {
    return this.http.delete<any>(`${this.communicationConfigService.getApiUri()}/document/delete-doc/${idDoc}`);
  }

  // updateDocument(
  //   table: string,
  //   idTableLinked: number,
  //   bodyReq: MAmzone.IAmazoneUploadReponse,
  //   idDoc: string
  // ): Observable<{ success: boolean }> {
  //   const body = {
  //     amzone: bodyReq,
  //     id_doc: idDoc
  //   }
  //   return this.http.post<{ success: boolean }>(
  //     `${this.communicationConfigService.getApiUri()}/document/update/table/${table}/${idTableLinked}`,
  //     body
  //   );
  // }
}
